// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import Util from "./utils/util.js";
import axios from "axios";
// import KeFu from './utils/kefu.js'
import VueCookies from "vue-cookies";
import validate from "./utils/validate";
import Antd from "ant-design-vue";
import copy from "./utils/copy";
import ConfigProvider from "ant-design-vue";
import "ant-design-vue/dist/antd.css";
import "./assets/css/customAntd.css";
import "./assets/css/resetAntd.css";
import "./assets/css/common.css";
import VueLazyload from "vue-lazyload";
import "./assets/css/global.css";
// console.log(KeFu);
Vue.config.productionTip = false;
Vue.prototype.$util = Util;
Vue.prototype.$axios = axios;
// Vue.prototype.$kefu = KeFu
Vue.use(VueCookies);
Vue.use(validate);
Vue.use(Antd);
Vue.use(ConfigProvider);
Vue.use(copy);
Vue.use(VueLazyload);
Vue.prototype.$EventBus = new Vue();

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title + " - 用户中心 - 91家纺网";
  }

  if (to.meta.link) {
    window.location.href = Util.getHost() + to.meta.link;
    return;
  }

  // if(to.name == 'Login'){
  //     if(Util.loginStatus() == true){
  //         next({
  //             path: '/'
  //         })
  //     }
  // }

  if (to.meta.requireAuth) {
    if (Util.loginStatus() == false) {
      next({
        path: "/login",
      });
    } else {
      next();
    }
  }

  next();
});

/* eslint-disable no-new */

new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>",
});



// WEBPACK FOOTER //
// ./src/main.js